import { Routes } from '@angular/router';
import { authGuard, permissionsGuard, PERMISSIONS } from '@joyinvoice/web/shared/data-access';
import { LayoutComponent } from '@joyinvoice/web/shared/ui';

export const appRoutes: Routes = [
  // Public routes (no auth required)
  {
    path: 'auth',
    loadChildren: () =>
      import('@joyinvoice/web/auth/feature').then(m => m.AUTH_ROUTES),
  },

  // Protected routes (auth required)
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('@joyinvoice/web/dashboard/feature').then(
            m => m.DashboardComponent,
          ),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('@joyinvoice/web/subscriptions/feature').then(
            m => m.subscriptionsRoutes,
          ),
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('@joyinvoice/web/invoices/feature').then(
            m => m.INVOICE_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.INVOICES_READ },
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('@joyinvoice/web/customers/feature').then(
            m => m.CUSTOMER_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.CUSTOMERS_READ },
      },
      {
        path: 'suppliers',
        loadChildren: () =>
          import('@joyinvoice/web/suppliers/feature').then(
            m => m.SUPPLIER_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.SUPPLIERS_READ },
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@joyinvoice/web/products/feature').then(
            m => m.PRODUCT_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.PRODUCTS_READ },
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('@joyinvoice/web/categories/feature').then(
            m => m.CATEGORY_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.CATEGORIES_READ },
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('@joyinvoice/web/payments/feature').then(
            m => m.PAYMENT_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.PAYMENTS_READ },
      },
      {
        path: 'recurring',
        loadChildren: () =>
          import('@joyinvoice/web/recurring/feature').then(
            m => m.RECURRING_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.RECURRING_READ },
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('@joyinvoice/web/reports/feature').then(m => m.REPORT_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.REPORTS_READ },
      },
      {
        path: 'taxes',
        loadChildren: () =>
          import('@joyinvoice/web/taxes/feature').then(m => m.TAX_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.TAXES_READ },
      },
      {
        path: 'warehouses',
        loadChildren: () =>
          import('@joyinvoice/web/warehouses/feature').then(m => m.WAREHOUSE_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.WAREHOUSES_READ },
      },
      {
        path: 'users',
        loadChildren: () =>
          import('@joyinvoice/web/users/feature').then(m => m.USER_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.USERS_READ },
      },
      {
        path: 'safes',
        loadChildren: () =>
          import('@joyinvoice/web/safes/feature').then(m => m.SAFE_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.SAFES_READ },
      },
      {
        path: 'roles',
        loadChildren: () =>
          import('@joyinvoice/web/roles/feature').then(m => m.ROLE_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.ROLES_READ },
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('@joyinvoice/web/inventory/feature').then(m => m.INVENTORY_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.INVENTORY_READ },
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('@joyinvoice/web/notifications/feature').then(m => m.NOTIFICATION_ROUTES),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.NOTIFICATIONS_READ },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('@joyinvoice/web/settings/feature').then(
            m => m.SETTINGS_ROUTES,
          ),
        canActivate: [permissionsGuard],
        data: { permission: PERMISSIONS.SETTINGS_READ },
      },
    ],
  },

  // Wildcard
  { path: '**', redirectTo: 'dashboard' },
];
